import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { serviceCallTechnicalGuideTab } from "./tabs-content/tabs-content-technical-guide";
import { serviceCallHistoryTab } from "./tabs-content/tabs-content-history";
import { serviceReportsTab } from "./tabs-content/tabs-content-reports";
import { serviceCallContactsTab } from "./tabs-content/tabs-content-contact";
import { getModalEditTemplate } from "../modals/modals/modal-edit";
import { getModalCallbackTemplate } from "../modals/modals/modal-callback";
import { getModalCloseTemplate } from "../modals/modals/modal-close";
import { getModalEditSuccessTemplate } from "../modals/modals/modal-edit-success";
import { getModalCallbackSuccessTemplate } from "../modals/modals/modal-callback-success";
import { getModalCloseSuccessTemplate } from "../modals/modals/modal-close-success";
import { getModalAddOrderNumberTemplate } from "../modals/modals/modal-add-order-number";
import { renderPageTemplate } from "../../../../utils";
import { mockData } from "../../../../components/dynamic-href/mock-data";

const Template = (args) => {
    const templateArgs = {
        ...args,
    };
    const {
        withNotification,
        withServiceTimes,
        withEditSuccess,
        withCallbackSuccess,
        withCloseSuccess,
    } = templateArgs;
    const tpl = html`
        <div class="ux-row ux-u-flex-jc-center">
            ${getHeaderTemplate(templateArgs)} ${getNavigationRowTemplate()}
            ${getDetailTemplate(templateArgs)} ${getNavigationRowTemplate()}
        </div>
        ${withNotification
            ? getNotificationModalTemplate(withServiceTimes)
            : ""}
        ${getModalEditTemplate()} ${getModalCallbackTemplate()}
        ${getModalCloseTemplate()}
        ${getModalAddOrderNumberTemplate(false, "add-order-number-modal")}
        ${getModalAddOrderNumberTemplate(true, "edit-order-number-modal")}
        ${withEditSuccess ? getModalEditSuccessTemplate() : ""}
        ${withCallbackSuccess ? getModalCallbackSuccessTemplate() : ""}
        ${withCloseSuccess ? getModalCloseSuccessTemplate() : ""}
    `;
    return tpl;
};

export default {
    title: "MyTrumpf/Page Templates/My Service Cases/Detail",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        withNotification: false,
        withServiceTimes: false,
        withServiceReports: false,
        withEditSuccess: false,
        withCallbackSuccess: false,
        withCloseSuccess: false,
        withOrderNumberRequired: false,
    },
    argTypes: {
        withNotification: {
            control: {
                type: "boolean",
            },
        },
        withServiceTimes: {
            control: {
                type: "boolean",
            },
        },
        withServiceReports: {
            control: {
                type: "boolean",
            },
        },
        withEditSuccess: {
            control: {
                type: "boolean",
            },
        },
        withCallbackSuccess: {
            control: {
                type: "boolean",
            },
        },
        withCloseSuccess: {
            control: {
                type: "boolean",
            },
        },
        withOrderNumberRequired: {
            control: {
                type: "boolean",
            },
        },
        hasOrderNumber: {
            control: {
                type: "boolean",
            },
        },
    },
};

const getOrderNumberToast = () => html`
    <div class="ux-u-mb-m">
        <ux-message-box
            type="warning"
            headline="Order number required"
            no-close-button
        >
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
        </ux-message-box>
    </div>
`;

const getNavigationRowTemplate = () => html`
    <div
        class="service-calls-detail__navigation-row ux-col-10 ux-u-mt-xs ux-u-mb-l"
    >
        <ux-button href="#">
            <ux-icon name="chevron-left"></ux-icon> Zurück
        </ux-button>
    </div>
`;

const getHeaderTemplate = ({
    withOrderNumberRequired = false,
    hasOrderNumber = false,
}) => {
    return html`
        <div
            class="service-calls-detail__header ux-col-10 ux-u-mt-s ux-u-mt-md-xl"
        >
            ${withOrderNumberRequired && !hasOrderNumber
                ? getOrderNumberToast()
                : ""}
            <div class="case-overview__headline ux-u-mb-l">
                <div class="ux-text-headline ux-text-headline--giant">
                    Software
                    <ux-w-status type="SERVICE_CALL_Closed"
                        >Fall abgeschlossen</ux-w-status
                    >
                </div>
                <div
                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                >
                    TRUPUNCH 5000 Mittelformat - TWDEDEMO010
                </div>
            </div>
            <div class="ux-row">
                <div
                    class="service-calls-detail__header-details ux-col-12 ux-col-lg-9"
                >
                    <div class="ux-row">
                        <div
                            class="labeled-text ux-col-12 ux-col-sm-3 ux-u-mb-md-xxs"
                        >
                            <div class="labeled-text__text-block">
                                <div
                                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                >
                                    Fallnummer
                                </div>
                                <div class="ux-text-normal">
                                    <p>5317472</p>
                                </div>
                            </div>
                        </div>
                        <div
                            class="labeled-text ux-col-12 ux-col-sm-3 ux-u-mb-md-xxs"
                        >
                            <div class="labeled-text__text-block">
                                <div
                                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                >
                                    Ersteller
                                </div>
                                <div class="ux-text-normal">
                                    <p>Paul Schumacher</p>
                                </div>
                            </div>
                        </div>
                        <div
                            class="labeled-text ux-col-12 ux-col-sm-3 ux-u-mb-md-xxs"
                        >
                            <div class="labeled-text__text-block">
                                <div
                                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                >
                                    Erstellt am
                                </div>
                                <div class="ux-text-normal">
                                    <p>
                                        <ux-date-time
                                            utc="2020-05-01 17:32:33"
                                            format="DD.MM.YYYY"
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            class="labeled-text ux-col-12 ux-col-lg-10 ux-u-mt-xxxs ux-u-mt-md-xs ux-u-mb-s"
                        >
                            <div class="labeled-text__text-block">
                                <div
                                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                >
                                    Beschreibung
                                </div>
                                <div class="ux-text-normal">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur
                                        adipisicing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna
                                        aliqua. Ut enim ad minim veniam, quis
                                        nostrud exercitation ullamco laboris
                                        nisi ut aliquip ex ea commodo consequat.
                                        Duis aute irure dolor in reprehenderit
                                        in voluptate velit esse cillum dolore eu
                                        fugiat nulla pariatur.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="service-calls-detail__button-group ux-col-12 ux-col-lg-3"
                >
                    ${withOrderNumberRequired && !hasOrderNumber
                        ? html`
                              <ux-button
                                  variant="primary"
                                  data-trigger-modal="open,add-order-number-modal"
                              >
                                  Add order number
                              </ux-button>
                          `
                        : ""}
                    ${hasOrderNumber
                        ? html`
                              <ux-button
                                  data-trigger-modal="open,edit-order-number-modal"
                              >
                                  Edit order number
                              </ux-button>
                          `
                        : ""}
                    <ux-button
                        data-trigger-async-modal="open,serviceCallsModal-amend"
                        title="Add information to case"
                    >
                        Add information to case
                    </ux-button>
                    <ux-button data-trigger-modal="open,modal-callback">
                        Callback request
                    </ux-button>
                    <ux-button data-trigger-modal="open,modal-close">
                        Close case
                    </ux-button>
                    <ux-iws-dynamic-href endpoint="${mockData.link}">
                        <div slot="link">
                            <a
                                href="#"
                                class="ux-button ux-button--primary"
                                data-track-event-name="click_my_link"
                                >Satisfaction Survey</a
                            >
                        </div>
                        <div slot="fallback"></div>
                    </ux-iws-dynamic-href>
                </div>
            </div>
        </div>
    `;
};

const getDetailTemplate = ({ withServiceReports }) => html`
    <div class="service-calls-detail__details ux-col-12 u-background-gray">
        <div class="ux-row ux-u-flex-jc-center ux-gutter-zero">
            <div class="case-details ux-col-10 ux-u-my-l u-background-white">
                <div class="ux-row ux-u-flex-jc-center">
                    <div
                        class="case-details__inner ux-col-12 ux-col-lg-10 ux-u-px-xs"
                    >
                        <ux-tab-container
                            data-x-scroll-when-activated
                            bold-tab-buttons
                            active-tab-id="2"
                            nav-arrows
                            fix-to-top
                        >
                            <ux-tab
                                name="Technical Guide"
                                tab-id="1"
                                class="ux-tab-technical-guide ux-u-mt-m"
                            >
                                ${serviceCallTechnicalGuideTab()}
                            </ux-tab>
                            <ux-tab
                                name="Verlauf"
                                tab-id="2"
                                class="ux-tab-history ux-u-mt-m"
                            >
                                ${serviceCallHistoryTab()}
                            </ux-tab>
                            <ux-tab
                                name="Hinterlegter Kontakt"
                                tab-id="3"
                                class="ux-tab-contact ux-u-mt-m"
                            >
                                ${serviceCallContactsTab()}
                            </ux-tab>
                            ${withServiceReports
                                ? html`
                                      <ux-tab
                                          name="Reports"
                                          tab-id="4"
                                          class="ux-tab-reports ux-u-mt-m"
                                      >
                                          ${serviceReportsTab()}
                                      </ux-tab>
                                  `
                                : ""}
                        </ux-tab-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
`;

const getNotificationModalTemplate = (withServiceTimes) => html`
    <ux-modal
        name="notification-modal"
        close-on-backdrop-click
        close-on-esc-key
    >
        <ux-modal-content>
            <div class="ux-u-text-align--center ux-u-mb-xxs">
                <ux-icon
                    style="font-size: 100px"
                    class="ux-color-success"
                    name="checkmark-rounded-thin"
                ></ux-icon>
                <div class="ux-text-headline--big">
                    Your Case was created successfully.
                </div>
                ${withServiceTimes
                    ? html`
                          <div class="ux-text-normal">
                              <p>
                                  Please note that cases created outside out
                                  service hours will not be processed
                                  immediately. <br />
                                  <strong
                                      >Our Service Times are: Monday to Friday
                                      05:30 - 19:00</strong
                                  >
                              </p>
                              <p>
                                  If you need immediate assistance, please call
                                  TRUMPF technical service (+49 7156 123456) for
                                  support
                              </p>
                          </div>
                      `
                    : ""}
                <div class="ux-text-headline--big">
                    Technical Guide available
                </div>
                <div class="ux-text-normal">
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit, sed do eiusmod tempor incididunt ut labore et
                        dolore magna aliqua. Ut enim ad minim veniam, quis
                        nostrud exercitation ullamco laboris nisi ut aliquip ex
                        ea commodo consequat.
                    </p>
                </div>
            </div>
        </ux-modal-content>
        <ux-modal-footer>
            <ux-button
                data-trigger-modal="close,notification-modal"
                variant="primary"
            >
                OK
            </ux-button>
            ${withServiceTimes
                ? html`
                      <span class="ux-modal-footer__spacer"></span>
                      <ux-button href="tel:+497156123456"
                          >Call Technical Service</ux-button
                      >
                  `
                : ""}
        </ux-modal-footer>
    </ux-modal>
`;

export const Default = () => renderPageTemplate(() => Template({}));

export const OrderNumberRequired = () =>
    renderPageTemplate(() =>
        Template({
            withOrderNumberRequired: true,
        })
    );

export const OrderNumberAvailable = () =>
    renderPageTemplate(() =>
        Template({
            withOrderNumberRequired: true,
            hasOrderNumber: true,
        })
    );
